import React, { Component } from 'react';
import {
  Button,
  Divider,
  Paper,
  TextField,
  Grid,
  Modal
} from '@material-ui/core';
import PropTypes from 'prop-types';
import isEmail from 'validator/lib/isEmail';
import i18n from '../../i18n';

import StringItemSelector from './StringItemSelector';
import '../../assets/stylesheets/Setting.css';
import validateAgentFieldsHasErrors from '../../helpers/validationHelpers';

const initialState = {
  edited: {
    agencyId: false,
    firstName: false,
    lastName: false,
    email: false,
    phoneNumber: false
  },
  error: false
};

class EditAgentModal extends Component {
  constructor(props) {
    super(props);
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      agencyId
    } = props.selectedAgent;
    this.state = {
      ...initialState,
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId,
      originalAgent: props.selectedAgent
    };
  }

  handleSave = () => {
    const { onSave } = this.props;
    const {
      agencyId,
      firstName,
      lastName,
      email,
      phoneNumber,
      edited,
      originalAgent
    } = this.state;
      let agent = {
        id: originalAgent.id
      };
      if (edited.agencyId) {
        agent = {
          ...agent,
          agencyId
        }
      }
      if (edited.firstName) {
        agent = {
          ...agent,
          firstName
        }
      }
      if (edited.lastName) {
        agent = {
          ...agent,
          lastName
        }
      }
      if (edited.email) {
        agent = {
          ...agent,
          email
        }
      }
      if (edited.phoneNumber) {
        agent = {
          ...agent,
          phoneNumber
        }
      }
      onSave(agent);
  };

  handleChange = event => {
    event.persist();
    const { name, value } = event.target;

    if (name === 'phoneNumber') {
      this.setState(
        prevState => {
          return {
            phoneNumber: {
              Home: value
            },
            edited: {
              ...prevState.edited,
              phoneNumber: prevState.originalAgent.phoneNumber.Home !== value
            }
          };
        },
        () => this.validateFields()
      );
    } else {
      this.setState(
        prevState => {
          return {
            [name]: value,
            edited: {
              ...prevState.edited,
              [name]: prevState.originalAgent[name] !== value
            }
          };
        },
        () => this.validateFields()
      );
    }
  };

  onAgencyChange = event => {
    const { value } = event.target;
    if (value) {
      this.setState(
        prevState => {
          return {
            agencyId: value,
            edited: {
              ...prevState.edited,
              agencyId: prevState.originalAgent.agencyId !== value
            }
          };
        },
        () => this.validateFields()
      );
    }
  };

  onClose = () => {
    const { onClose } = this.props;
    this.setState(
      prevState => {
        return {
          ...initialState,
          firstName: prevState.originalAgent.firstName,
          lastName: prevState.originalAgent.lastName,
          email: prevState.originalAgent.email,
          agencyId: prevState.originalAgent.agencyId,
          phoneNumber: prevState.originalAgent.phoneNumber
        };
      },
      () => onClose()
    );
  };

  updateSelectedAgent = agent => {
    const { firstName, lastName, phoneNumber, email, agencyId } = agent;
    this.setState({
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId,
      originalAgent: agent
    });
  };

  validateFields = () => {
    const { firstName, lastName, email, phoneNumber, agencyId } = this.state;
    const updatedError = validateAgentFieldsHasErrors({
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId,
    });
    this.setState({ error: updatedError });
  };

  render() {
    const { agencies, showModal } = this.props;
    const {
      error,
      edited,
      firstName,
      lastName,
      email,
      phoneNumber,
      agencyId
    } = this.state;

    const isEdited =
      edited.firstName ||
      edited.lastName ||
      edited.email ||
      edited.phoneNumber ||
      edited.agencyId;

    return (
      <Modal open={showModal} onClose={this.onClose}>
        <Paper className="addAgentModal">
          <Grid container>
            <Grid item xs={12}>
              {i18n.t('setting:editAgent')}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                value={firstName}
                error={edited.firstName && firstName === ''}
                id="agent firstName"
                label={i18n.t('setting:agentFirstName')}
                name="firstName"
                autoFocus
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                value={lastName}
                required
                fullWidth
                error={edited.lastName && lastName === ''}
                id="agent lastName"
                label={i18n.t('setting:agentLastName')}
                name="lastName"
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                value={email}
                required
                fullWidth
                error={edited.email && !isEmail(email)}
                id="agent email"
                label={i18n.t('setting:agentEmail')}
                name="email"
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                value={phoneNumber.Home}
                required
                fullWidth
                error={edited.phoneNumber && phoneNumber.Home === ''}
                id="agent phoneNumber"
                label={i18n.t('setting:agentPhoneNumber')}
                name="phoneNumber"
                onChange={this.handleChange}
              />
              <StringItemSelector
                selectedItem={agencyId}
                items={agencies}
                required
                error={edited.agencyId && agencyId === 0}
                onItemChange={this.onAgencyChange}
                label={i18n.t('setting:chooseAgency')}
                helperText={i18n.t('setting:agencyAgentHelp')}
              />
              <Divider />
              <br />
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={this.handleSave}
                className="ssenseButton ssensePrimary"
                disabled={error || !isEdited}
              >
                {i18n.t('save')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={this.onClose}
                className="ssenseButton ssenseDefault"
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

EditAgentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedAgent: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.object,
      PropTypes.bool
    ])
  ).isRequired,
  agencies: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default EditAgentModal;
